module.exports = __webpack_public_path__ + "static/img/12.08b32aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/2/eng/12.png
// module id = H8XL
// module chunks = 0